<div
  [ngClass]="'alert-' + severity"
  [class.alert-with-colour]="colouredBackground"
  [class.alert-with-title]="titleText"
  class="alert"
  data-test="alert"
>
  <div *ngIf="showIcon; else iconPlaceholder">
    <fa-icon
      [ngClass]="'alert-icon-' + severity"
      [icon]="severityIcons[severity]"
      class="icon alert-icon"
      data-test="alert-icon"
      [title]="severityIconAria[severity]"
    ></fa-icon>
    <span class="sr-only">{{ severityIconAria[severity] }}</span>
  </div>

  <!-- Show either content or title.
    If title exists, then content will be rendered on the next row below.-->
  <span
    *ngIf="titleText; else messageTpl"
    class="alert-title mat-body-1"
    data-test="alert-title"
  >
    {{ titleText }}
  </span>

  <!--  Rendering this element even when 'actionType' is null for grid alignment -->
  <div [ngSwitch]="actionType" class="alert-action" data-test="alert-action">
    <button
      *ngSwitchCase="'close'"
      matRipple
      class="button-reset"
      data-test="alert-close-btn"
      (click)="closed.emit()"
      [attr.aria-label]="dismissAria[severity]"
    >
      <fa-icon
        [icon]="closeIcon"
        class="icon icon-close"
        data-test="alert-close-icon"
      ></fa-icon>
    </button>

    <!-- Can't use Material Button, because they have fixed size. -->
    <button
      *ngSwitchCase="'action'"
      matRipple
      class="button-reset action-btn"
      data-test="alert-action-btn"
      (click)="action.emit()"
    >
      {{ actionBtnText || 'Action' }}
    </button>
  </div>

  <ng-container *ngIf="titleText" [ngTemplateOutlet]="messageTpl">
  </ng-container>
</div>

<ng-template #messageTpl>
  <div data-test="alert-message" class="alert-message mat-body-2">
    <ng-template
      *ngIf="isTemplateRef(message)"
      [ngTemplateOutlet]="message"
    ></ng-template>
    <span *ngIf="!isTemplateRef(message)">{{ message }}</span>
  </div>
</ng-template>

<ng-template #iconPlaceholder>
  <span class="icon alert-icon" aria-hidden="true"></span>
</ng-template>
